module.exports = __webpack_public_path__ + "assets/background.16e3fc83c2d526b8a3a86978bc74b1fa.jpg";